import React, { useMemo, useState } from "react";

import { copy } from "shared/assets";
import { InputField } from "shared/components";
import { VisuallyHiddenElement } from "shared/styles/constants";
import { IFieldType } from "shared/types";
import { Eye } from "shared/assets/icons";

import { PasswordIcon } from "./styles";
import { InputFieldProps } from "../InputField";
import { Icon } from "shared/styles";

export const PasswordField: React.FC<InputFieldProps> = ({ type, ...rest }) => {
  const [fieldType, setFieldType] = useState(type);
  const isPassword = useMemo(() => fieldType === IFieldType.password, [fieldType]);

  return (
    <InputField
      type={fieldType}
      {...rest}
      suffix={
        <PasswordIcon
          type="button"
          isHidden={!isPassword}
          onClick={() => setFieldType(isPassword ? IFieldType.text : IFieldType.password)}
        >
          <Icon as={Eye} size="l" />
          <VisuallyHiddenElement>
            {isPassword ? copy.form.showPassword : copy.form.hidePassword}
          </VisuallyHiddenElement>
        </PasswordIcon>
      }
    />
  );
};
